export default "__VITE_ASSET__BoDawjT2__"